import { useEffect, useMemo, useState } from "react";
import { RETRO_TABS } from "../mock/retroMockData";

const VALID_TABS = new Set(RETRO_TABS.map((t) => t.key));

export function useRetroViewState(viewModel) {
  const [activeTab, setActiveTab] = useState("dash");

  const [radarPeriod, setRadarPeriod] = useState("week");
  const [radarSeriesA, setRadarSeriesA] = useState("");
  const [radarSeriesB, setRadarSeriesB] = useState("__target");

  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [memberGoalCadence, setMemberGoalCadence] = useState("weekly");

  const [submitOpen, setSubmitOpen] = useState(false);
  const [selectedWeekId, setSelectedWeekId] = useState("");
  const [visibility, setVisibility] = useState("reviewer");
  const [submittedWeeks, setSubmittedWeeks] = useState({});

  const [promptDrafts, setPromptDrafts] = useState({});

  useEffect(() => {
    const out = {};
    (viewModel?.submitReflection?.weeks || []).forEach((w) => {
      out[w.id] = !!w.submitted;
    });
    setSubmittedWeeks(out);
  }, [viewModel?.submitReflection?.weeks]);

  useEffect(() => {
    const weeks = viewModel?.submitReflection?.weeks || [];
    if (!weeks.length) return;
    setPromptDrafts((prev) => {
      const next = { ...prev };
      weeks.forEach((w) => {
        if (!w?.answers) return;
        next[w.id] = {
          ...(w.answers || {}),
          ...(next[w.id] || {}),
        };
      });
      return next;
    });
  }, [viewModel?.submitReflection?.weeks]);

  useEffect(() => {
    const hash = (window.location.hash || "#dash").replace("#", "");
    if (VALID_TABS.has(hash)) setActiveTab(hash);
  }, []);

  useEffect(() => {
    if (window.location.hash !== `#${activeTab}`) {
      window.history.replaceState(null, "", `${window.location.pathname}#${activeTab}`);
    }
  }, [activeTab]);

  const radarPool = useMemo(() => {
    return viewModel?.dashboard?.radar?.seriesByPeriod?.[radarPeriod] || [];
  }, [viewModel, radarPeriod]);

  useEffect(() => {
    if (!radarPool.length) return;
    setRadarSeriesA((curr) => curr || radarPool[0].id);
    setRadarSeriesB((curr) => {
      if (curr === "__target") return curr;
      if (radarPool.some((p) => p.id === curr)) return curr;
      return "__target";
    });
  }, [radarPool]);

  useEffect(() => {
    const weeks = viewModel?.submitReflection?.weeks || [];
    if (!selectedWeekId && weeks.length) {
      const firstOpen = weeks.find((w) => !submittedWeeks[w.id]);
      setSelectedWeekId(firstOpen?.id || weeks[0].id);
    }
  }, [viewModel, selectedWeekId, submittedWeeks]);

  const setPromptValue = (key, value) => {
    setPromptDrafts((prev) => ({ ...prev, [selectedWeekId]: { ...(prev[selectedWeekId] || {}), [key]: value } }));
  };

  const submitCurrentWeek = () => {
    if (!selectedWeekId) return;
    setSubmittedWeeks((prev) => ({ ...prev, [selectedWeekId]: true }));
    setSubmitOpen(false);
  };

  return {
    tabs: RETRO_TABS,
    activeTab,
    setActiveTab,

    radarPeriod,
    setRadarPeriod,
    radarSeriesA,
    setRadarSeriesA,
    radarSeriesB,
    setRadarSeriesB,

    selectedMemberId,
    setSelectedMemberId,
    memberGoalCadence,
    setMemberGoalCadence,

    submitOpen,
    setSubmitOpen,
    selectedWeekId,
    setSelectedWeekId,
    visibility,
    setVisibility,
    submittedWeeks,
    promptDrafts,
    setPromptValue,
    submitCurrentWeek,
  };
}
